import React from "react";
import NxTopology from"./NxTopology"
import Next from"./Next"


function NetWorkConfig (){

    return(
        <>
          <Next/>
         {/* <NxTopology/> */}
       
        </>
    )
}

export default NetWorkConfig;